import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

const PrivateRoute = ({ children, isLoggedIn, userType, allowedRoles = [] }) => {
  const navigate = useNavigate();

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(userType)) {
    return (
      <div className="container text-center mt-5">
        <div className="p-4 border rounded shadow-sm" style={{ maxWidth: '500px', margin: 'auto' }}>
          <h2 className="mb-3 text-danger">⛔ Acceso no autorizado</h2>
          <p>No tienes permiso para acceder a esta sección.</p>
          <button
            className="btn w-100"
            style={{
              background: 'linear-gradient(to right, var(--mm-cyan), #0E8C86)',
              color: '#06222B',
              fontWeight: 'bold',
              border: 'none',
              borderRadius: '10px',
              padding: '10px 0',
              marginTop: '20px'
            }}
            onClick={() => navigate(-1)}
          >
            ⬅️ Volver
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default PrivateRoute;
